import UserApi from '@/frontend/api/user';
import { ElMessage, ElLoading } from 'element-plus';
import 'element-plus/es/components/loading/style/css';
import Yandex from "@/frontend/classes/yandex";
export default {
  name: "RegistrationPage",

  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      hiddenPassword: true,
      agreePolicy: false
    };
  },

  computed: {
    passwordType() {
      return this.hiddenPassword ? 'password' : 'text';
    }

  },
  methods: {
    handlerSubmit() {
      let loader;

      if (!this.agreePolicy) {
        ElMessage({
          message: 'Подтвердите согласие с политикой обработки данных',
          type: 'warning'
        });
        return;
      }

      loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      UserApi.signUp(this.form).then(() => {
        loader.close();
        this.$store.dispatch('setEmail', this.form.email);
        Yandex.metrika('reachGoal', 'itsok9');
        this.$router.push({
          name: 'verification'
        });
      }).catch(error => {
        loader.close();

        if (!error) {
          console.error(error);
          ElMessage.error(error.message || 'Непредвиденная ошибка!');
          return;
        }

        if (error.type === 'validate' || error.type === 'not found') {
          ElMessage({
            message: Array.isArray(error.message) ? error.message[0] : error.message,
            type: 'warning'
          });
          console.log(error);
          return;
        }

        ElMessage.error('Отсутствует обработчик ошибки!');
        console.error(error);
      });
    }

  }
};